module.exports = __webpack_public_path__ + "static/1.2.C.4 Plan de situatie-e735924ec1b91fe9ec3f9301d3a90b25.jpg";